export default __webpack_public_path__ + "static/media/pagtrust.d6651b9b.png";